import { useEffect, useState } from "react";
import { toast } from "sonner";
import { apiCall, euro, Sel, BASES, yearOptions } from "./rUtils";

const K = ({ label, value, cls = "text-white" }) => <div className="flex justify-between text-xs"><span className="text-[#71717A]">{label}</span><span className={cls}>{value}</span></div>;

export function MonthOverview({ token, onPickMonth, onYears }) {
  const [year, setYear] = useState(String(new Date().getFullYear()));
  const [basis, setBasis] = useState("invoice");
  const [d, setD] = useState(null);
  useEffect(() => {
    apiCall(token, `/rechnungen/admin/overview?year=${year}&basis=${basis}`).then((r) => { setD(r); onYears(r.years); }).catch((e) => toast.error(e.message));
  }, [token, year, basis, onYears]);
  const t = d?.total;
  return (
    <div data-testid="month-overview">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <h3 className="font-['Bebas_Neue'] text-3xl text-white mr-2">Rechnungen {year}</h3>
        <Sel value={year} onChange={setYear} options={yearOptions(d?.years)} testId="overview-year" />
        <Sel value={basis} onChange={setBasis} options={BASES.map(([v, l]) => [v, `Zuordnung nach ${l}`])} testId="overview-basis" />
      </div>
      {t && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5" data-testid="overview-year-total">
          {[["Ausgestellt", t.issued_sum, `${t.count} Rechnungen`, "text-white"], ["Zahlungseingänge", t.payments_received, "nach Zahlungsdatum", "text-green-300"],
            ["Offene Forderungen", t.open_sum, `davon überfällig ${euro(t.overdue_sum)}`, "text-yellow-300"], ["Storniert/korrigiert", t.cancelled_sum, `${t.cancelled_count} Belege`, "text-red-300"]].map(([l, v, sub, c]) => (
            <div key={l} className="bg-[#121212] border border-white/10 p-4"><div className="text-xs uppercase tracking-wider text-[#71717A]">{l}</div><div className={`font-['Bebas_Neue'] text-3xl ${c}`}>{euro(v)}</div><div className="text-xs text-[#71717A]">{sub}</div></div>
          ))}
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {d?.months.map((m) => (
          <button key={m.month} type="button" onClick={() => onPickMonth(year, m.month, basis)} className={`text-left bg-[#1A1A1A] border p-4 space-y-1 transition-colors hover:border-[#c1ff72]/50 ${m.count ? "border-white/10" : "border-white/5 opacity-50"}`} data-testid={`month-card-${m.month}`}>
            <div className="flex justify-between items-baseline"><span className="font-['Bebas_Neue'] text-2xl text-white">{m.name}</span><span className="text-xs text-[#71717A]">{m.count} Rechn.</span></div>
            <K label="Ausgestellt" value={euro(m.issued_sum)} />
            <K label="Bezahlt" value={euro(m.paid_sum)} cls="text-green-300" />
            <K label="Offen" value={euro(m.open_sum)} cls="text-yellow-300" />
            <K label="Teilweise bezahlt" value={euro(m.partial_sum)} cls="text-orange-300" />
            <K label="Storniert/korrigiert" value={euro(m.cancelled_sum)} cls="text-red-300" />
            <K label="Zahlungseingänge" value={euro(m.payments_received)} cls="text-green-400" />
          </button>
        ))}
      </div>
      {d?.undated_count > 0 && <p className="text-xs text-orange-300 mt-3">{d.undated_count} Belege ohne passendes Datum für diese Zuordnung (z. B. noch nicht bezahlt).</p>}
    </div>
  );
}
